import React, { useState, FunctionComponent, useEffect } from 'react';

interface Item {
  key: string;
  value: string;
}

interface IProps {
  placeholder?: string;
  includeSelectedItem?: boolean;
  onChange: (value: string) => void;
  values: Item[];
  value: string;
  required?: boolean;
  valid?: boolean;
}

const Dropdown: FunctionComponent<IProps> = ({ placeholder, includeSelectedItem, values, onChange, value, required = false, valid = true }) => {
  const firstValue = values.find(x => x.key === value);
  const [isOpen, setIsOpen] = useState(false);
  const [_value, setValue] = useState(firstValue?.value || `${placeholder} ${required ? '*' : ''}` || '');

  useEffect(() => {
    const body = document.querySelector('body');
    if (!body) {
      return;
    }

    body.addEventListener('click', _close);

    return () => body.removeEventListener('click', _close);
  }, []);

  const _setIsOpen = (e: React.MouseEvent) => {
    e.stopPropagation();

    setIsOpen(!isOpen);
  };

  const _close = () => {
    setIsOpen(false);
  };

  const onChangeInternal = (item: Item) => {
    setValue(item.value);
    onChange(item.key);
    setIsOpen(false);
  };

  const filteredItems = () => {
    if (!includeSelectedItem) {
      return values.filter(x => x.value !== _value);
    }

    return values;
  };

  return (
    <div className="form__row">
      <div className={`form__control form__dropdown ${isOpen ? 'active' : ''} ${!valid ? "invalid" : ""}`}>
        <div className="form__dropdown-selected" onClick={_setIsOpen} dangerouslySetInnerHTML={{ __html: _value }}>
        </div>
        <div className="form__dropdown-values">
          {filteredItems().map(x => (
            <div key={x.key} className="form__dropdown-value" onClick={() => onChangeInternal(x)} dangerouslySetInnerHTML={{ __html: x.value }}></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
